module.exports = ['computer', 'trello', 'link', 'google-drive', 'dropbox', 'box', 'onedrive']